export default __webpack_public_path__ + "static/media/janine.a3a3e5e8.jpeg";